module.exports = __webpack_public_path__ + "static/media/sm-foundation-logo.260c1a4e.png";